cb.define(['common/common_VM.Extend.js'], function (common) {


    var PM_pmc_pricepreferentiallist_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var gridModel = viewmodel.getGridModel();

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(args.carry.rowData.id, 'pmc_pricepreferential');
            })

            gridModel.on('afterSetDataSource', () => {
                common.displayListButton(gridModel);
            });


        }
    };
    try {
        module.exports = PM_pmc_pricepreferentiallist_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_pricepreferentiallist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_pricepreferentiallist_VM.Extend.js